import { useEffect } from 'react'
import type { InfiniteData } from '@tanstack/react-query'
import {
  getFollowMeFeedPostsRemovedTopic,
  isFollowMeFeedPostRemovePayload,
  iotSubscribeTopics,
  iotUnsubscribeTopics,
} from '@core/State/PushData'
import { queryKeys } from '@core/Data/ReactQuery/constants'
import { queryClient } from '@core/Data/ReactQuery/queryClient'
import type { FollowMeSharedBet } from '../types'

export function useSharedBetsTopicSubscription() {
  useEffect(() => {
    const topic = getFollowMeFeedPostsRemovedTopic()

    const subscription = iotSubscribeTopics([topic]).subscribe(data => {
      if (!isFollowMeFeedPostRemovePayload(data.payload)) return
      const postId = Number(data.payload.postId)
      if (!postId) return

      queryClient.setQueriesData(
        { queryKey: queryKeys.followMeSharedBetsFeedBase() },
        updateSharedBetStatus(postId)
      )
    })

    return () => {
      subscription.dispose()
      iotUnsubscribeTopics([topic])
    }
  }, [])
}

// =============
// Local Helpers
// =============

const updateSharedBetStatus =
  (id: FollowMeSharedBet['postId']) =>
  (
    oldData: InfiniteData<FollowMeSharedBet[]> | undefined
  ): InfiniteData<FollowMeSharedBet[]> | undefined => {
    if (!oldData) return oldData
    return {
      ...oldData,
      pages: oldData.pages.map(page =>
        page.map(bet => {
          if (bet.postId === id) {
            const newBet: FollowMeSharedBet = {
              ...bet,
              ticket: { ...bet.ticket, status: 'BettingClosed' },
            }
            return newBet
          } else {
            return bet
          }
        })
      ),
    }
  }
